import React from 'react';
import { CheckCircle, Circle, Truck, Package, Warehouse, Home, XCircle } from 'lucide-react';

const StatusTimeline = ({ statusHistory }) => {
  const getStatusIcon = (status, isCompleted) => {
    const lowerStatus = status.toLowerCase();
    
    if (lowerStatus.includes('delivered')) {
      return <CheckCircle className="w-6 h-6 text-green-600" />;
    }
    if (lowerStatus.includes('denied') || lowerStatus.includes('not found')) {
      return <XCircle className="w-6 h-6 text-red-600" />;
    }
    if (lowerStatus.includes('warehouse')) {
      return <Warehouse className={`w-6 h-6 ${isCompleted ? 'text-blue-600' : 'text-gray-400'}`} />;
    }
    if (lowerStatus.includes('moving') || lowerStatus.includes('on road')) {
      return <Truck className={`w-6 h-6 ${isCompleted ? 'text-blue-600' : 'text-gray-400'}`} />;
    }
    if (lowerStatus.includes('picked')) {
      return <Package className={`w-6 h-6 ${isCompleted ? 'text-blue-600' : 'text-gray-400'}`} />;
    }
    if (lowerStatus.includes('left for delivery')) {
      return <Home className={`w-6 h-6 ${isCompleted ? 'text-blue-600' : 'text-gray-400'}`} />;
    }
    
    return isCompleted ? 
      <CheckCircle className="w-6 h-6 text-blue-600" /> : 
      <Circle className="w-6 h-6 text-gray-400" />;
  };

  return (
    <div 
      className="space-y-6"
      data-component-path="client/src/components/StatusTimeline.jsx"
      data-component-line="1:1"
      data-component-id="client/src/components/StatusTimeline.jsx:1:1"
    >
      {statusHistory.map((item, index) => {
        const isLast = index === statusHistory.length - 1;
        const isCompleted = true;

        return (
          <div 
            key={index} 
            className="relative flex gap-4"
            data-component-path="client/src/components/StatusTimeline.jsx"
            data-component-line="2:5"
            data-component-id="client/src/components/StatusTimeline.jsx:2:5"
          >
            {/* Timeline Line */}
            {!isLast && (
              <div 
                className="absolute left-3 top-10 bottom-0 w-0.5 bg-gray-300"
                data-component-path="client/src/components/StatusTimeline.jsx"
                data-component-line="3:9"
                data-component-id="client/src/components/StatusTimeline.jsx:3:9"
              ></div>
            )}

            {/* Icon */}
            <div 
              className="relative z-10 flex-shrink-0"
              data-component-path="client/src/components/StatusTimeline.jsx"
              data-component-line="4:7"
              data-component-id="client/src/components/StatusTimeline.jsx:4:7"
            >
              <div 
                className="w-12 h-12 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center"
                data-component-path="client/src/components/StatusTimeline.jsx"
                data-component-line="5:9"
                data-component-id="client/src/components/StatusTimeline.jsx:5:9"
              >
                {getStatusIcon(item.status, isCompleted)}
              </div>
            </div>

            {/* Content */}
            <div 
              className="flex-1 pb-8"
              data-component-path="client/src/components/StatusTimeline.jsx"
              data-component-line="6:7"
              data-component-id="client/src/components/StatusTimeline.jsx:6:7"
            >
              <div 
                className={`p-4 rounded-lg border-2 ${
                  isLast ? 'bg-blue-50 border-blue-300' : 'bg-gray-50 border-gray-200'
                }`}
                data-component-path="client/src/components/StatusTimeline.jsx"
                data-component-line="7:9"
                data-component-id="client/src/components/StatusTimeline.jsx:7:9"
              >
                <h4 
                  className="font-bold text-gray-800 text-lg mb-1"
                  data-component-path="client/src/components/StatusTimeline.jsx"
                  data-component-line="8:11"
                  data-component-id="client/src/components/StatusTimeline.jsx:8:11"
                >
                  {item.status}
                </h4>
                <p 
                  className="text-sm text-gray-600 mb-2"
                  data-component-path="client/src/components/StatusTimeline.jsx"
                  data-component-line="9:11"
                  data-component-id="client/src/components/StatusTimeline.jsx:9:11"
                >
                  {item.timestamp}
                </p>
                {item.location && (
                  <p 
                    className="text-sm text-gray-700 flex items-center gap-1"
                    data-component-path="client/src/components/StatusTimeline.jsx"
                    data-component-line="10:13"
                    data-component-id="client/src/components/StatusTimeline.jsx:10:13"
                  >
                    <span 
                      className="font-medium"
                      data-component-path="client/src/components/StatusTimeline.jsx"
                      data-component-line="11:15"
                      data-component-id="client/src/components/StatusTimeline.jsx:11:15"
                    >
                      📍 Location:
                    </span> {item.location}
                  </p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatusTimeline;